import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * The people clocked in to the project right now, once each and the
 * signed-in user left out, with what it takes to call them:
 * GET projects/{projectId}/clocked-in-people →
 * `{ people: [{ firstName, lastName, employerName, phone, picture }] }`
 * (no ids: the first API version also sent userId and resourceId and listed
 * the caller, which the list still copes with). The backend answers 403
 * unless the project grants resources_view_clocked_in, view_other_resources
 * or manage_company_resources.
 */
export const getClockedInPeople = async ({ projectId }) => {
  const apiPath = `projects/${projectId}/clocked-in-people`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
